function _fieldIncludes(fieldName, value, courses) {
  const fieldValue = value ? value.toLowerCase() : null;
  const filteredCourses = fieldValue
    ? courses.docs.filter((course) => course[fieldName] && course[fieldName].toLowerCase().includes(fieldValue))
    : courses.docs;

  return {
    docs: filteredCourses,
    page: 1,
    pages: 1,
    total: filteredCourses.length
  };
}

function _filterDuration(duration, courses) {
  if (!duration || duration === 'any') return courses;
  const [min, max] = duration.split('-').map((val) => parseInt(val));
  const durationCourses = courses.docs.filter((course) => {
    const courseDuration = (course.hours || 0) * 60 + (course.minutes || 0);
    return courseDuration >= min && courseDuration <= max;
  });
  return {
    docs: durationCourses,
    page: 1,
    pages: 1,
    total: durationCourses.length
  };
}

function _filterAccessMode(accessMode, courses) {
  const accessModeCourses =
    accessMode && accessMode !== 'any'
      ? courses.docs.filter((course) => course.accessMode === accessMode)
      : courses.docs;
  return {
    docs: accessModeCourses,
    page: 1,
    pages: 1,
    total: accessModeCourses.length
  };
}

function _filterStatus(publish, courses) {
  const publishModeCourses =
    publish && publish !== 'any'
      ? courses.docs.filter((course) => {
          if (publish === 'withdrawn') return course.withdrawn;
          if (course.withdrawn) return false;
          return publish === 'publish' ? course.publish.active : !course.publish.active;
        })
      : courses.docs;
  return {
    docs: publishModeCourses,
    page: 1,
    pages: 1,
    total: publishModeCourses.length
  };
}

function _filterDiploma(diploma, courses) {
  const diplomaCourses =
    diploma && diploma !== 'any'
      ? courses.docs.filter((course) => `${course.configuration.shouldSendDiploma}` === diploma)
      : courses.docs;
  return {
    docs: diplomaCourses,
    page: 1,
    pages: 1,
    total: diplomaCourses.length
  };
}

function _filterLanguages(languages, courses) {
  const langCourses =
    languages && languages.length
      ? courses.docs.filter((course) => languages.every((lang) => course.languages.includes(lang)))
      : courses.docs;
  return {
    docs: langCourses,
    page: 1,
    pages: 1,
    total: langCourses.length
  };
}

function _filterCourses(modules, courses) {
  const numModules = parseInt(modules) || 0;
  const modulesCourses = numModules
    ? courses.docs.filter((course) => course.modules.length === numModules)
    : courses.docs;
  return {
    docs: modulesCourses,
    page: 1,
    pages: 1,
    total: modulesCourses.length
  };
}

const COURSES_FILTERS = {
  accessMode: (courses, options) => _filterAccessMode(options.filters.accessMode, courses),
  clientName: (courses, options) => _fieldIncludes('clientName', options.filters.clientName, courses), // creator
  duration: (courses, options) => _filterDuration(options.filters.duration, courses),
  languages: (courses, options) => _filterLanguages(options.filters.languages, courses),
  courses: (courses, options) => _filterCourses(options.filters.courses, courses),
  name: (courses, options) => _fieldIncludes('name', options.filters.name, courses),
  title: (courses, options) => _fieldIncludes('title', options.filters.title, courses),
  status: (courses, options) => _filterStatus(options.filters.status, courses),
  topic: (courses, options) => _fieldIncludes('topic', options.filters.topic, courses),
  shouldSendDiploma: (courses, options) => _filterDiploma(options.filters.shouldSendDiploma, courses),
  search: (courses, options) => {
    const { search } = options;
    if (!search) {
      return courses;
    } else {
      const searchTerm = search.toLowerCase();
      const filteredCourses = courses.docs.filter(
        (course) =>
          (course.name && course.name.toLowerCase().includes(searchTerm)) ||
          (course.title && course.title.toLowerCase().includes(searchTerm)) ||
          (course.gameName && course.gameName.toLowerCase().includes(searchTerm)) ||
          (course.topic && course.topic.toLowerCase().includes(searchTerm)) ||
          (course.creator && course.creator.toLowerCase().includes(searchTerm)) ||
          (course.clientName && course.clientName.toLowerCase().includes(searchTerm)) ||
          (course.tags &&
            course.tags.length &&
            course.tags.some((tag: string) => tag.toLowerCase().includes(searchTerm)))
      );
      return {
        docs: filteredCourses,
        page: 1,
        pages: 1,
        total: filteredCourses.length
      };
    }
  },

  // ???
  selectedOwner: (courses, options) => {
    const { selectedOwner = 'all', clientId, partnerId } = options.filters;
    let ownerCourses = [];
    switch (selectedOwner) {
      case 'all':
        ownerCourses = courses.docs;
        break;
      case 'gamelearn':
        // Courses with a type different from 'game' are customizations
        ownerCourses = courses.docs.filter((course) => course.clientName == 'Gamelearn');
        break;
      case 'myCourses':
      case 'myItineraries':
        // Courses/Itineraries created in Editor/Admin by the client
        ownerCourses = clientId ? courses.docs.filter((course) => course.clientId === clientId) : [];
        break;
      case 'partner':
        ownerCourses = partnerId ? courses.docs.filter((course) => course.clientId === partnerId) : [];
        break;
      case 'certified':
        // TODO When certified courses exist
        break;
    }

    return {
      docs: ownerCourses,
      page: 1,
      pages: 1,
      total: ownerCourses.length
    };
  }
};

export const filterCourses = (courses, options) => {
  const result = Object.keys(COURSES_FILTERS).reduce((filteredCourses, filter) => {
    return COURSES_FILTERS[filter](filteredCourses, options);
  }, courses);
  return result;
};
